/* Base */
.eds-placeholder-media {
  --_bar-gap: var(--eds--padding-16);
  --_bar-height-1: var(--eds--size-16);
  --_bar-height-2: var(--eds--size-32);
  --_bar-height-3: var(--eds--size-48);
  --_bar-height-4: var(--eds--size-72);
  --_bar-height-5: var(--eds--size-48);
  --_bar-width: var(--eds--size-8);
  --_media-height: 180px;
  --_media-width: 360px;

  flex: none;
  height: var(--_media-height);
  max-width: 100%;
  width: min(100%, var(--_media-width));
}

.eds-placeholder-media--loading {
  align-items: center;
  display: flex;
  gap: var(--_bar-gap);
  justify-content: center;
}

.eds-placeholder-media--illustration {
  display: block;
  object-fit: contain;
}

/* Icon mode has a single fixed size, independent of the illustration `size`
   sizes below — there is no s/m/l variant for the icon badge. */
.eds-placeholder-media--icon-badge {
  align-items: center;
  background-color: var(--eds--color--bg-muted-soft);
  border-radius: var(--eds--radii-8);
  display: flex;
  flex: none;
  height: var(--eds--size-40);
  justify-content: center;
  width: var(--eds--size-40);
}

.eds-placeholder-media--bar {
  animation: eds-placeholder-media-pulse 1.2s ease-in-out infinite;
  border-radius: var(--eds--radii-full);
  flex: none;
  width: var(--_bar-width);
}

/* Heights and colors read left-to-right off the Figma waveform; bar 6 mirrors
   bar 1's height (both are the shortest) but keeps its own color. */
.eds-placeholder-media--bar--1 {
  animation-delay: 0s;
  background-color: var(--eds--palette-red-400);
  height: var(--_bar-height-1);
}

.eds-placeholder-media--bar--2 {
  animation-delay: 0.1s;
  background-color: var(--eds--palette-blue-400);
  height: var(--_bar-height-2);
}

.eds-placeholder-media--bar--3 {
  animation-delay: 0.2s;
  background-color: var(--eds--palette-green-400);
  height: var(--_bar-height-3);
}

.eds-placeholder-media--bar--4 {
  animation-delay: 0.3s;
  background-color: var(--eds--palette-red-400);
  height: var(--_bar-height-4);
}

.eds-placeholder-media--bar--5 {
  animation-delay: 0.4s;
  background-color: var(--eds--palette-blue-400);
  height: var(--_bar-height-5);
}

.eds-placeholder-media--bar--6 {
  animation-delay: 0.5s;
  background-color: var(--eds--palette-green-400);
  height: var(--_bar-height-1);
}

/* Sizes — bar dimensions scale with the media box, matching the Figma S/M/L frames. */
.eds-placeholder-media--size-s {
  --_bar-gap: var(--eds--padding-10);
  --_bar-height-1: var(--eds--size-12);
  --_bar-height-2: var(--eds--size-20);
  --_bar-height-3: var(--eds--size-32);
  --_bar-height-4: var(--eds--size-48);
  --_bar-height-5: var(--eds--size-32);
  --_bar-width: var(--eds--size-4);
  --_media-height: 120px;
  --_media-width: 240px;
}

.eds-placeholder-media--size-m {
  --_bar-gap: var(--eds--padding-16);
  --_bar-height-1: var(--eds--size-16);
  --_bar-height-2: var(--eds--size-32);
  --_bar-height-3: var(--eds--size-48);
  --_bar-height-4: var(--eds--size-72);
  --_bar-height-5: var(--eds--size-48);
  --_bar-width: var(--eds--size-8);
  --_media-height: 180px;
  --_media-width: 360px;
}

.eds-placeholder-media--size-l {
  --_bar-gap: var(--eds--padding-20);
  --_bar-height-1: var(--eds--size-24);
  --_bar-height-2: var(--eds--size-40);
  --_bar-height-3: var(--eds--size-64);
  --_bar-height-4: var(--eds--size-96);
  --_bar-height-5: var(--eds--size-72);
  --_bar-width: var(--eds--size-12);
  --_media-height: 240px;
  --_media-width: 480px;
}

@keyframes eds-placeholder-media-pulse {
  0%,
  100% {
    opacity: 0.45;
    transform: scaleY(0.72);
  }

  50% {
    opacity: 1;
    transform: scaleY(1);
  }
}
